import React from 'react'
 type IProps ={
    subHeader :string ;
    className? :String ;
 }
const ReportSubHeader = ({subHeader ,className}:IProps) => {
  return (
    <h2 className={`text-center text-white mx-2 p-3 mt-5 ${className}`} style={{backgroundColor :"#073763"}}>{subHeader}</h2>
  )
}

export default ReportSubHeader
